export const FRAMEWORK_PACK_IDS = [
  "marshall_goldsmith_stakeholder_centered",
  "grow",
  "immunity_to_change",
  "solution_focused",
  "co_active",
  "authentic_leadership",
  "radical_candor",
  "adaptive_leadership",
  "executive_presence",
  "inclusive_leadership",
  "servant_leadership",
] as const;

export type FrameworkPackId = (typeof FRAMEWORK_PACK_IDS)[number];

export type FrameworkPackSource = "curated" | "primary_source";
export type FrameworkPackFamily = "veera_core" | "coach_custom";

export interface FrameworkPackPreview {
  philosophySummary: string;
  whatItNotices: string[];
  watchouts: string[];
  sampleCoachLanguage: string[];
  sampleLeaderLanguage: string[];
}

export interface FrameworkPackRuntime {
  coreConstructs: string[];
  diagnosticQuestions: string[];
  interventionPatterns: string[];
  progressMarkers: string[];
  stallSignals: string[];
}

export interface FrameworkNoticingSignal {
  id: string;
  label: string;
  description: string;
  positiveIndicators: string[];
  negativeIndicators: string[];
  evidenceHints: string[];
  prohibitedInferences: string[];
}

export interface FrameworkReflectionPattern {
  id: string;
  label: string;
  promptTemplates: string[];
  useWhen: string[];
  avoidWhen: string[];
}

export interface FrameworkBoundary {
  allowed: string[];
  prohibited: string[];
  coachOnly: string[];
}

export interface FrameworkPackOperationalization {
  noticingSignals: FrameworkNoticingSignal[];
  reflectionPatterns: FrameworkReflectionPattern[];
  boundaries: FrameworkBoundary;
  salienceWeights: Record<string, number>;
}

export interface FrameworkPackDefinition {
  id: FrameworkPackId;
  label: string;
  family: FrameworkPackFamily;
  source: FrameworkPackSource;
  preview: FrameworkPackPreview;
  runtime: FrameworkPackRuntime;
  operationalization: FrameworkPackOperationalization;
}
